import React, { useEffect, useState } from "react";
import { BooleanInput, Create, useNotify, useRedirect, SelectInput, SimpleForm, TextInput } from "react-admin";

// Providers
import { Organization, organizationsProvider } from "../../providers/organizations";

// Hooks
import useValidators from "../../hooks/useValidators";

export const CreateComponent: React.FC = () => {
  const { text } = useValidators();
  const notify = useNotify();
  const redirect = useRedirect();

  const [organizations, setOrganizations] = useState<Organization[] | null>(null);

  const onSuccess = () => {
    notify(`Controller created successfully`, { type: "success" });
    redirect("list", "controllers");
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  const fetchData = async () => {
    const response = await organizationsProvider.getMany();

    if (response) {
      const availableLocations = response as unknown as Organization[];
      setOrganizations(availableLocations);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Create mutationOptions={{ onSuccess, onError }}>
      <SimpleForm mode="onBlur" reValidateMode="onBlur">
        <TextInput label="Name" source="name" validate={text} />
        <TextInput label="Serial" source="serial_number" validate={text} />
        <BooleanInput label="Active" source="is_active" />
        <SelectInput
          emptyText="No organization selected"
          source="organizationId"
          isPending={organizations === null}
          choices={organizations || []}
        />
      </SimpleForm>
    </Create>
  );
};
